// extracted by mini-css-extract-plugin
export var errorsContainer = "_tv-1";
export var link = "_tv-0";